import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { HeaderHelperService } from '../header-helper.service';
import { MealLog } from '../../models/survey/meal-log.model';

@Injectable({
  providedIn: 'root',
})
export class SurveyService {
  constructor(
    private http: HttpClient,
    private headerHelperService: HeaderHelperService
  ) {}

  surveysByApplicationCode(): Observable<any> {
    let url = `${environment.apiLocations.survey}/Survey/GetSurveysByApplicationCode`;

    return this.http.get<any>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  caseSurveys(id: string): Observable<any> {
    let url = `${environment.apiLocations.survey}/Survey/PatientRecordCaseSurveys/${id}`;

    return this.http.get<any>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  schedulers(id: string): Observable<any> {
    let url = `${environment.apiLocations.survey}/Scheduler/${id}`;

    return this.http.get<any>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  deleteScheduler(id: string): Observable<void> {
    return this.http.delete<void>(
      `${environment.apiLocations.survey}/Scheduler/${id}`,
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }

  measurement(id: string): Observable<any> {
    let url = `${environment.apiLocations.survey}/Measurement/${id}`;

    return this.http.get<any>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  patientAnswer(id: string): Observable<any> {
    let url = `${environment.apiLocations.survey}/PatientAnswer/GetSurveyResponsesByPatientRecordCase?PatientRecordCaseId=${id}`;

    return this.http.get<any>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  surveyAnswerByMeasurementDateQuery(
    id: string,
    dateToBeMeasured: string
  ): Observable<any> {
    let url = `${environment.apiLocations.survey}/Measurement/GetSurveyAnswerByMeasurementDate?PatientRecordCaseId=${id}&DateToBeMeasured=${dateToBeMeasured}`;

    return this.http.get<any>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  getPreparationPageSurveys(): Observable<any> {
    let url = `${environment.apiLocations.survey}/Survey/GetPreparationPageSurveys`;

    return this.http.get<any>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  mealLogsByCaseId(patientRecordCaseId: string): Observable<MealLog[]> {
    const url = `${environment.apiLocations.survey}/Meal/${patientRecordCaseId}`;

    return this.http.get<MealLog[]>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }
}
